// @flow

import { getApi, patchRaw, postRaw } from './api.core'

export const getInsuranceType = params => getApi(`api/insurance-type/`, params)
export const createInsuranceType = params =>
  postRaw(`api/insurance-type/batch/`, params)
export const updateInsuranceType = (id, params) =>
  patchRaw(`api/insurance-type//${id}/`, params)
